import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row items-start gap-12 lg:gap-20">
          <div className="flex-1">
            <span className="text-xs font-semibold text-foreground-500 uppercase tracking-[0.2em]">
              About Kakobuy Spreadsheet
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 mt-3 leading-tight">
              What Is Kakobuy Spreadsheet And Why It Works
            </h2>
            <p className="text-base text-foreground-600 leading-relaxed mt-6 max-w-2xl">
              <strong className="text-foreground-900">Kakobuy Spreadsheet</strong> is a structured product discovery resource that helps shoppers quickly find trending products, compare options, and organize their shopping journey. Unlike traditional browsing that wastes hours scrolling through endless pages, the spreadsheet format gives you immediate access to curated, verified listings organized by category, price range, and quality rating.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-8">
              {[
                { icon: 'ri-database-2-line', title: 'Product Databases', desc: 'Thousands of listings across 14 categories, updated regularly with new finds and verified by community feedback.' },
                { icon: 'ri-price-tag-3-line', title: 'Price Comparison', desc: 'Side-by-side pricing across sellers so you always get the best deal without manually checking each store.' },
                { icon: 'ri-shield-check-line', title: 'Quality Checking', desc: 'Community-verified ratings and detailed seller notes help you avoid low-quality products before buying.' },
                { icon: 'ri-flashlight-line', title: 'Shopping Efficiency', desc: 'Save 3-10 hours per shopping session by using filtered, organized data instead of browsing blindly.' },
              ].map((item) => (
                <div key={item.title} className="flex items-start gap-3 p-4 rounded-xl bg-background-100/70">
                  <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-100/70 text-accent-700 flex-shrink-0">
                    <i className={`${item.icon} text-lg`}></i>
                  </span>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-900">{item.title}</h4>
                    <p className="text-xs text-foreground-600 mt-1 leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <Link
              to="/kakobuy-spreadsheet-guide"
              className="inline-flex items-center gap-2 mt-8 px-6 py-3 text-sm font-semibold text-background-50 bg-primary-500 rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              Start Exploring Kakobuy Spreadsheet
              <i className="ri-arrow-right-line text-base"></i>
            </Link>
          </div>

          <div className="flex-shrink-0 w-full lg:w-[420px] flex flex-col gap-4">
            <div className="w-full h-[260px] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Close%20up%20editorial%20product%20shot%20of%20a%20pair%20of%20premium%20suede%20sneakers%20in%20warm%20tan%20and%20cream%20colors%20placed%20on%20a%20light%20travertine%20stone%20pedestal%20soft%20diffused%20natural%20light%20from%20a%20skylight%20minimalist%20luxury%20boutique%20setting%20warm%20earth%20tones%20high%20resolution%20commercial%20product%20photography%20with%20subtle%20shadow%20detail&width=840&height=520&seq=about-sneaker-v2&orientation=landscape"
                alt="Premium suede sneakers from Kakobuy Spreadsheet collection in minimalist editorial photography"
                title="Kakobuy Spreadsheet Shoes Collection"
                className="w-full h-full object-cover object-center"
              />
            </div>
            <div className="w-full h-[260px] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20draped%20fabric%20arrangement%20showcasing%20a%20camel%20wool%20overcoat%20a%20cashmere%20turtleneck%20sweater%20and%20a%20silk%20scarf%20artistically%20hung%20on%20a%20minimalist%20brass%20clothing%20rack%20against%20a%20warm%20plaster%20wall%20soft%20boutique%20lighting%20warm%20neutral%20earth%20tones%20editorial%20fashion%20photography%20high%20resolution%20commercial%20style&width=840&height=520&seq=about-clothing-v2&orientation=landscape"
                alt="Fashion items from Kakobuy Spreadsheet featuring coats and knitwear in clean editorial style"
                title="Kakobuy Spreadsheet Fashion Collection"
                className="w-full h-full object-cover object-center"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}